import React, { useState } from "react";
import PropTypes from "prop-types";

// Components
import ImagesIpsativesButton from "../../../../components/ImagesIpsativesButton";
import SurveyImagesIpsative from "../../../../components/SurveyImagesIpsative";
import RatingStar from "../../../../components/RatingStar";


const SurveyImagesIpsativeItem = (props) => {


  const [itemsShown, setItemsShown] = useState({});
  const _renderItems = (index, itemData) => {
    switch(itemData.item_format_style) {
      case 3:
        return []
      case 5:
        return _starsInputs(index, itemData)
      default:
        return []
    }
  }

  const _handleRatingStar = (index, data, selected) => {
    return props.handleClick({...selected, [index]: data});
  };
  const _starsInputs = (index, itemData) => {
    return (
      <div className="c-answer" key={`answer-${index}`}>
        <div className="c-answer__indicator">
          <span className="c-answer__indicator-text">{itemData.text}</span>
        </div>
        <span className="c-answer__text"> {itemData.name} </span>
        <RatingStar
          key={index}
          values={itemData.items}
          currentValue={props.selectedItems[index] || {}}
          onClick={(e, i, val) =>
            _handleRatingStar(index, val, props.selectedItems)
          }
        />
      </div>
    )
  }
  const _submit = (competence) => {
    props.handleClick({ [competence]: props.questionData.items[competence] })
  }  

  return (
      <div className="o-container o-pos-rel c-ipsative">
          {/*
            props.submitting &&
            <CompetenceSuccess />
          */}
          {
            !props.submitting &&
            <React.Fragment>
              <div className="c-ipsative__wrapper">
                <SurveyImagesIpsative items={props.questionData.items || []}/>    
                {/*
                  Object.entries(props.questionData.items).map((item, index) => {
                    {if(Object.keys(itemsShown).length == 0) setItemsShown(item[1])}
                    return (
                      <SurveyImagesIpsative key={"survey_image_"+index} items={props.questionData.items || []}/>    
                    )                    
                  })  
                */}
              </div>
              <div className="c-ipsative__wrapper-button">
                <ImagesIpsativesButton showHint={props.step === 0} selectedItems={props.selectedItems} itemsShown={props.questionData.items} isFirstQuestion={props.isFirstQuestion} submit={(competence) => _submit(competence)} />
              </div>
            </React.Fragment>
          }
      </div>

  )
}


export default SurveyImagesIpsativeItem;
